














































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { IGameDescriptionAsset } from '~/store/games/types';
@Component
export default class MediaCarousel extends Vue {
  @Prop(Array) readonly assets!: IGameDescriptionAsset[];
  @Prop(Number) readonly windowWidth!: number;

  current = 0;
  showFullSize = false;
  thumbWidth = '0px';
  thumbLeft = '0';
  thumbnailsLoaded = 0;
  scrollBarThumbPosition = { left: 0, x: 0 };
  timer: any = null;
  isMP4 = false;
  isVideoActive = false;
  hasVideoEnded = false;
  rotationOccured = false;

  get activeAsset() {
    this.updateMP4Status();
    return this.assets[this.current];
  }
  get backDisabled() {
    return this.activeAsset?.thumbnail === this.assets[0].thumbnail;
  }
  get forwardDisabled() {
    return (
      this.activeAsset?.thumbnail ===
      this.assets[this.assets.length - 1].thumbnail
    );
  }

  mounted() {
    this.preloadImages();
    this.setThumbWidth();
    this.timer = setInterval(this.handleNext, 6000);
  }

  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  videoEnded() {
    if (!this.hasVideoEnded) {
      this.hasVideoEnded = true;
      this.isVideoActive = false;
    }
  }

  updateCurrent(index: number) {
    this.current = index;
    this.updateMP4Status();
    this.rotationOccured = true;
    this.isVideoActive = false;
  }

  onThumbnailLoaded() {
    this.thumbnailsLoaded++;
    if (this.thumbnailsLoaded >= this.assets.length) {
      this.setThumbWidth();
    }
  }

  preloadImages() {
    this.assets.forEach(asset => {
      const image = new Image();
      image.src = asset.medium;
    });
  }

  updateMP4Status() {
    if (
      this.assets[this.current].type === 'video' ||
      this.assets[this.current].medium.endsWith('.mp4')
    ) {
      this.isMP4 = true;
    } else {
      this.isMP4 = false;
    }
  }

  handleNext() {
    if (this.activeAsset) {
      const container = this.$refs.thumbnailContainer as Element;
      const currentIndex = this.assets.findIndex(
        item => item.thumbnail === this.activeAsset?.thumbnail,
      );
      this.rotationOccured = true;
      this.isVideoActive = false;

      if (this.current === this.assets.length - 1) {
        this.current = 0;
        this.updateMP4Status();
        container.scrollLeft = 0;
      } else {
        this.current++;
        this.updateMP4Status();
        container.scrollBy(128, 0);
      }
    }
  }
  handlePrev() {
    if (!this.backDisabled && this.activeAsset) {
      const container = this.$refs.thumbnailContainer as Element;
      const currentIndex = this.assets.findIndex(
        item => item.thumbnail === this.activeAsset?.thumbnail,
      );
      this.rotationOccured = true;
      this.isVideoActive = false;

      container.scrollBy(-128, 0);
      this.current--;
      this.updateMP4Status();
    }
  }

  handleScroll() {
    const container = this.$refs.thumbnailContainer as Element;

    window.requestAnimationFrame(() => {
      this.thumbLeft = `${(container.scrollLeft * 100) /
        container.scrollWidth}%`;
    });
  }

  // Pauses carousel rotation when viewing full size image
  @Watch('showFullSize')
  handlePauseInterval(showFullSize: boolean, oldVal: boolean) {
    if (showFullSize && this.timer) {
      clearInterval(this.timer);
    } else if (!showFullSize) {
      this.timer = setInterval(this.handleNext, 6000);
    }
  }

  // Stops carousel rotation when video starts. Starts carousel rotation when video ends.
  @Watch('isVideoActive')
  handleVideoPlayAndStop(isVideoActive: boolean) {
    if (isVideoActive && this.timer) {
      clearInterval(this.timer);
    } else if (!isVideoActive && (this.hasVideoEnded || this.rotationOccured)) {
      this.hasVideoEnded = false;
      this.rotationOccured = false;
      this.timer = setInterval(this.handleNext, 6000);
    }
  }

  @Watch('windowWidth')
  setThumbWidth() {
    const container = this.$refs.thumbnailContainer as Element;
    if (!container) return;
    const scrollRatio = container.clientWidth / container.scrollWidth;
    this.thumbWidth = `${scrollRatio * 100}%`;
  }
}
